import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import * as actions from '../action';
import * as c from '../constant';

function AdditionalItemsTab({
  isLoading,
  getAdditionalItemLogs,
  historyList,
  historyInfo,
  showAdditionalItemLogs
}) {

  const OnSetFormHistory = () => {
    if (historyList.length > 0) {
      showAdditionalItemLogs(historyInfo.id, _.get(historyList, '0.id'));
    }
  };

  useEffect(() => {

    if (!_.isEmpty(historyInfo)) {
      getAdditionalItemLogs(historyInfo.id)
    }
  }, []);

  useEffect(() => {

    if (!_.isEmpty(historyInfo)) {
      getAdditionalItemLogs(historyInfo.id)
    };
  }, [historyInfo]);

  useEffect(() => {
    if (!_.isEmpty(historyList)) {
      OnSetFormHistory();
    }
  }, [historyList]);

  return (
    <>
      {isLoading ? (
        <div className="loading">
          <div className="spinner text-center">
            <span className="fas fa-1x fa-spin fa-spinner" />
          </div>
        </div>
      ) : (
        <>
          <div className="row my-3 mx-2">
            <table className="css-table table table-borderless table-sm table-striped table-hover">
              <thead className="table-header">
                <tr>
                  <td className="font-weight-bold">Floor</td>
                  <td className="font-weight-bold">Actual Use</td>
                  <td className="font-weight-bold">Component</td>
                  <td className="font-weight-bold">Area</td>
                  <td className="font-weight-bold">Rate</td>
                  <td className="font-weight-bold">Added Area to Building Core?</td>
                </tr>
              </thead>
              <tbody>
                {_.isEmpty(historyList) ? (
                  <tr className="w-100">
                    <td colSpan="6" className="text-center border-top p-4 text-muted">
                      This Section is Empty
                    </td>
                  </tr>
                ) : (
                  historyList.map(item => (
                    <tr key={item.id}>
                      <td className="history-color">{_.get(item, 'attributes.floor')}</td>
                      <td className="history-color">{_.get(item, 'included.actualUse.attributes.name') || ''}</td>
                      <td className="history-color">{_.get(item, 'included.buildingComponent.attributes.name') || ''}</td>
                      <td className="history-color">{_.get(item, 'attributes.area') || ''}</td>
                      <td className="history-color">PHP{' '}{_.get(item, 'attributes.rate') || ''}</td>
                      <td className="history-color">{_.get(item, 'attributes.is_add_area') ? 'Yes' : 'No' || ''}</td>
                    </tr>
                  )))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}

AdditionalItemsTab.defaultProps = {
  historyInfo: {}
};

AdditionalItemsTab.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  getAdditionalItemLogs: PropTypes.instanceOf(Function).isRequired,
  historyList: PropTypes.instanceOf(Array).isRequired,
  historyInfo: PropTypes.instanceOf(Object),
  showAdditionalItemLogs: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  historyList: _.get(api, `${c.GET_ADDITIONAL_ITEM_LOGS}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_ADDITIONAL_ITEM_LOGS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AdditionalItemsTab);
